import store from "store";
import { IStoreData } from "./interfaces";


export const setStore = (data: IStoreData | {}) => {
    if (!process.env.WEBPACK) return;
    store.set("homeworkState", data);
};

export const getStore = () => {
    if (!process.env.WEBPACK) return;
    const hwStorage = (store.get("homeworkState") || {}) as (IStoreData);
    return hwStorage;
};
